<template>
  <!--跟踪信息弹窗-->
  <Modal v-model="trackingModal" :title="$t('key1001520')" width="720" :transfer="false" :mask-closable="false"
    class-name="trackingStyle" @on-visible-change="trackingModalChange">
    <Card dis-hover>
      <template #title>
        <h2 class="trackinginfo_title_box">
          <Row type="flex" :gutter="gutterItem" style="width: 100%;">
            <Col :span="ItemCol" class="basic_item">
              <span class="basic_title">{{ $t('key1001521') }}</span>
              <span class="basic_txt">{{ trackingNumber }}</span>
            </Col>
            <Col :span="ItemCol" class="basic_item">
              <span class="basic_title">{{ $t('key1001522') }}</span>
              <span class="basic_txt">{{ trackingStatusTxt }}</span>
            </Col>
          </Row>
        </h2>
      </template>

      <Timeline>
        <TimelineItem v-for="(item, index) in timelineList" :key="index">
          <p class="time_box">{{ item.time }}</p>
          <p class="content_box" :title="item.statusDescription">{{ item.statusDescription }}</p>
        </TimelineItem>
      </Timeline>
    </Card>
    <template #footer>
      <div style="text-align: center;">
        <Button @click="trackingModal = false">{{ $t('key1000248') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "trackingInfoModal",
  mixins: [Mixin],
  data() {
    return {
      ItemCol: 8,
      trackingModal: false,
      timelineList: [],
      trackingStatusTxt: '',
      trackingNumber: ''
    };
  },
  methods: {
    // 获取跟踪信息的数据
    getPackageLogisticsTracking(ymsPackageId) {
      let v = this;
      let systemObj = {
        yms: api.get_ymsPackageInfo_searchLogisticsTracking,
        distributor: api.get_ymsDistributorPackageInfo_searchLogisticsTracking,
      };
      let url = systemObj[v.system];
      v.axios.get(url + ymsPackageId).then((res) => {
        if (res.data.code === 0) {
          v.trackingModal = true;
          let statusList = [
            {value: 'normal', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001511')},
            {value: 'pending', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001512')},
            {value: 'notfound', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001513')},
            {value: 'transit', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001514')},
            {value: 'pickup', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001515')},
            {value: 'delivered', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001516')},
            {value: 'undelivered', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001517')},
            {value: 'expired', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001518')},
            {value: 'exception', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001519')}
          ];
          if (res.data.datas) {
            let data = res.data.datas.data;
            let trackinfo = data.originInfo.trackinfo;
            if (trackinfo.length > 0) {
              trackinfo.map((item) => {
                item['time'] = item.date ? v.$uDate.dealTime(item.date, 'fulltime') : '';
              });
              v.timelineList = trackinfo;
            }
            v.trackingNumber = data.trackingNumber;
            statusList.map((ele) => {
              if (ele.value === data.status) {
                v.trackingStatusTxt = ele.name;
              }
            });
          }
        }
      });
    },
    // 监听弹窗
    trackingModalChange(value) {
      if (!value) {
        this.resetData();
      }
    },
    //重置数据
    resetData() {
      this.timelineList = [];
      this.trackingStatusTxt = '';
      this.trackingNumber = '';
    }
  }
};
</script>

<style lang="less" scoped>
.trackingStyle {
  .ivu-modal-body {
    max-height: 600px;
    overflow-y: auto;
  }

  .trackinginfo_title_box {
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      margin: 5px 10px 5px 0;
      font-size: 15px;
      color: #333;
      font-weight: bold;
    }
  }

  .content_box {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
